import React, { useEffect, useState } from "react";
import { clsx } from "clsx";
// @ts-ignore
import shopify from "shopify";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { ProductSellingGroups } from "./ProductSellingGroups/ProductSellingGroups";
import { ProductTags } from "./ProductTags/ProductTags";
import { ProductRatings } from "./ProductRatings/ProductRatings";
import { ProductPrice } from "./ProductPrice/ProductPrice";
import { ProductImages } from "./ProductImages/ProductImages";
import { ProductSwatches } from "./ProductSwatches/ProductSwatches";
import ProductWishlist from "./ProductWishlist/ProductWishlist";

export const ProductTile = ({
  product,
  swatches = [],
  siblings,
  show_add = false,
  show_price_inline = false,
  isLazy = true,
    settings,
}) => {
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [hasRetrievedMetafields, sethasRetrievedMetafields] = useState(false);
  const [colourName, setColourName] = useState('');
  const [colourSwatch, setColourSwatch] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useMobileBreakpoint(settings?.mobile_breakpoint || '1024');

  const showButtons = !isMobile;

  let productUrl = `/products/`;

  if (settings?.collection){
    // productUrl = `/collections/${settings.collection?.handle}/products/`;
    productUrl = `/products/`;
  }

  useEffect(() => {
    async function getMetafieldsAndSwatches() {
      const productMetafields = await shopify.getMetafieldsForProduct([`gid://shopify/Product/${product.id}`]);

      product.metafields = productMetafields[0]?.metafields;

      let swatchProducts: any = [];

      for (const metafield of product.metafields) {
        switch (metafield.key) {
          case "bottle_colour":
            setColourSwatch(metafield.value[0]);
            break;
          case "bottle_colour_name":
            setColourName(metafield.value[0]);
            break;
          // case "bottle_colour":
          //   currentColourHex = metafield.value[0];
          //   break;
          case "bottle_siblings":
            const relatedProductIds = [...metafield.value];

            const relatedProducts =
              await shopify.getMetafieldsForProduct(relatedProductIds);
            const processedRelatedProducts = new Set();

            relatedProducts.forEach((relatedProduct) => {
              const swatchProduct = {
                url: `${productUrl}${relatedProduct.handle}`, // Assuming `handle` is the URL or can be constructed to form the URL
                color: null,
                image: relatedProduct.image?.src || "", // Assuming `image` field exists and is directly accessible
                name: "", // Assuming `title` is the name
              };

              relatedProduct.metafields.forEach((relatedProductMetafield) => {
                if (relatedProductMetafield.key === "bottle_colour_name") {
                  swatchProduct.name = relatedProductMetafield.value[0];
                }
                if (relatedProductMetafield.key === "bottle_colour") {
                  swatchProduct.color = relatedProductMetafield.value[0];
                }
              });
              if (!processedRelatedProducts.has(swatchProduct.name)) {
                swatchProducts.push(swatchProduct);
                processedRelatedProducts.add(swatchProduct.name); // Mark this URL as processed
              }
            });
            break;
        }
      }

      sethasRetrievedMetafields(true);
      setRelatedProducts(swatchProducts);
    }

    if (isHovered && !hasRetrievedMetafields) {
      getMetafieldsAndSwatches();
    }
  }, [isHovered]);

  const createKeyValuePairs = (tags) => {
    const tagsArray = Array.isArray(tags) ? tags : [tags];

    return tagsArray.reduce((acc, tag) => {
      const [key, value] = tag.split(":");
      if (value) {
        if (acc[key]) {
          if (Array.isArray(acc[key])) {
            acc[key].push(value);
          } else {
            acc[key] = [acc[key], value];
          }
        } else {
          acc[key] = value;
        }
      }
      return acc;
    }, {});
  };

  const productSwatches: any = [];
  let variantFirstId = product.id;
  let isAvailable = false;

  if (product.variants) {
    if (product?.variants?.length > 0) {
      variantFirstId = product?.variants[0]?.id || product?.id;
      isAvailable = product?.variants[0]?.available;
    }
  }

  const showQuickAdd = false;
  const runQuickAddOnSpot = false;
  const showWishlist = settings?.globals?.product_tile_wishlist_show;
  const showPrice = settings?.globals?.product_tile_price_show;


  if (product.tags) {
    const productTags = createKeyValuePairs(product.tags);

    if (productTags?.colour) {
      const colors = Array.isArray(productTags.colour)
        ? productTags.colour
        : [productTags.colour];

      colors.forEach((colorHandle) => {
        const siblingProduct = siblings?.find(
          (sibling) => sibling.handle === colorHandle,
        );
        let isProduct = false;
        const matchingProduct = siblings?.find(
          (sibling) => sibling.handle === product.handle,
        );

        if (matchingProduct === siblingProduct) {
          isProduct = true;
        }
        if (siblingProduct) {
          productSwatches.push({
            url: `${productUrl}` + siblingProduct.handle,
            name: product.title,
            image:
              siblingProduct.images?.find((image) =>
                image.src?.match(/_s_|_s(\.|$)/),
              )?.src ||
              siblingProduct.images[siblingProduct.images?.length - 1].src,
            is_product: isProduct,
          });
        }
      });
    }

    if (relatedProducts) {
      const colors = Array.isArray(productTags.colour)
        ? productTags.colour
        : [productTags.colour];

      colors.forEach((colorHandle) => {
        const relatedProduct: any = relatedProducts?.find(
          (related:any) => related.handle === colorHandle,
        );
        let isProduct = false;
        const matchingProduct = relatedProducts?.find(
          (related:any) => related.handle === product.handle,
        );

        if (matchingProduct === relatedProduct) {
          isProduct = true;
        }
        if (relatedProduct) {
          productSwatches.push({
            url: `${productUrl}` + relatedProduct.handle,
            name: product.title,
            image:
              relatedProduct.images?.edges?.find((edge) =>
                edge.node.src?.match(/_s_|_s(\.|$)/),
              )?.node.src ||
              relatedProduct.images?.edges[
                relatedProduct.images.edges.length - 1
              ]?.node.src,
            is_product: isProduct,
          });
        }
      });
    }
  }

  const LayoutComponent:any = 'ajax-cart-product-form';
  return (
    <div
      className={`theme__product-card max-lg:h-full ${
        isHovered ? "theme__product-card--hovered" : ""
      }`}
      onMouseEnter={(!isMobile && isAvailable) ? () => setIsHovered(true) : undefined}
      onMouseLeave={(!isMobile && isAvailable) ? () => setIsHovered(false) : undefined}
    >
      <div className="productcard__content max-lg:h-full">
        <ProductImages product={product} productUrl={productUrl} isLazy={isLazy} />

        <div className="flex justify-between w-full p-1 lg:p-2 pb-0 max-lg:items-center">
          <ProductRatings product={product} />
          <ProductPrice product={product} />
        </div>

        {runQuickAddOnSpot && <LayoutComponent class="w-full max-lg:mt-auto">
          <form
            action="/cart/add"
            id="product_form_id"
            className="product-form"
            noValidate
            data-prodify-product-form
          >
            <div className="flex justify-between p-1 pt-0 lg:p-2 gap-2 flex-col lg:flex-row items-center">
              <div className="flex w-full">
                <a href={`${productUrl}` + product?.handle}>
                  <p className="hidden lg:block b3">{product?.title || product?.name}</p>
                  <p className="lg:hidden b4">{product?.title || product?.name}</p>
                </a>
              </div>
              {(showButtons) && <div className="flex ml-auto shrink-0 max-lg:w-full">
                <input type="hidden" name="id" value={`${variantFirstId}`} />
                {isAvailable
                  ? <button className={`button button-tertiary naked`}>Shop now</button>
                  : <button className={`button button-tertiary naked`} disabled>Out of stock</button>
                }
              </div>}
            </div>

            <div
              data-ajax-cart-errors="form"
              className="text-xs text-error-1"
            ></div>
          </form>
        </LayoutComponent>}
        {!runQuickAddOnSpot && (
            <div className="flex justify-between p-1 pt-0 lg:px-2 lg:pb-2 gap-2 flex-col lg:flex-row items-center">
              <div className="flex w-full">
                <a href={`${productUrl}` + product?.handle}>
                  <p className="hidden lg:block b3">{product?.title}</p>
                  <p className="lg:hidden b4">{product?.title}</p>
                </a>
              </div>
              {(showButtons) && <div className="flex ml-auto shrink-0 max-lg:w-full">
                {isAvailable
                    ? <a className={`button button-tertiary naked`} href={`${productUrl}`  + product?.handle}>Shop now</a>
                    : <button className={`button button-tertiary naked`} disabled>Out of stock</button>}
              </div>}
            </div>
        )
        }
        {product.tags && <ProductTags product={product} />}
        {showWishlist &&
          <ProductWishlist product={product} />
        }

        <div className={clsx(
            "transition-all duration-300 w-full h-[42px] bottom-[50px] absolute",
            {
              "max-h-0 opacity-0": !isHovered,
              "max-h-96 opacity-100 product-tile-hovered": isHovered,
            },
        )}>
          <div className="flex space-x-[28px] justify-center h-[42px] items-center" style={{ background: "rgba(255, 255, 255, 0.40)" }}>
            {product?.variants?.map((variant) => (
                <div className="flex b3 cursor-pointer" key={variant.id}>
                  {variant.option1 || variant.options[0]}
                </div>
            ))}
          </div>
        </div>

        {product?.selling_plan_groups?.length > 0 && (
          <div
            className={clsx(
              "product__selling-groups overflow-hidden transition-all duration-300",
              {
                "max-h-0 opacity-0": !isHovered,
                "max-h-96 opacity-100 product-tile-hovered": isHovered,
              },
            )}
          >
            <div className="flex flex-col mt-4">
              {relatedProducts.length > 0 && (
                <ProductSwatches
                  swatches={relatedProducts}
                  currentColor={colourName}
                  currentSwatch={colourSwatch}
                  showName={true}
                />
              )}
              <ProductSellingGroups product={product} showAddToCart={true} isInTile={true} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductTile;
